const prepareAlgoliaSwatchImages = (colorSwatches, regionIds) => {
  if (!colorSwatches) {
    return [];
  }

  if (!Array.isArray(colorSwatches)) {
    colorSwatches = [colorSwatches];
  }

  return colorSwatches
    .map((item) => {
      const parsedItem = JSON.parse(item);
      // Here we will discard swatches for not correct region.
      if (
        regionIds?.length &&
        parsedItem?.ctburegions?.regionID &&
        !regionIds.some((reg) =>
          parsedItem?.ctburegions.regionID.some(
            (el) => el === reg || el === 'global',
          ),
        )
      ) {
        return null;
      }

      return {
        img: parsedItem?.swatchImage,
        label: parsedItem?.marketingColor,
        value: parsedItem?.marketingColor,
      };
    })
    .filter((el) => el);
};

export default prepareAlgoliaSwatchImages;
